import DefaultCell from "application/components/DefaultCell";
import RowAction from "application/components/RowAction";
import formControl from "globals/form-control";

const getUpdateColumns = (onEdit, editExtension) => {
  return [
    {
      Header: "Extension",
      accessor: "extension",
      displayInList: true,
      allowInForm: true,
      allowFilter: true,
      dataType: "string",
      disabled: editExtension ? true : false,
      width: 4,
      Cell: ({ value }) => <DefaultCell value={value} />,
    },
    {
      Header: "AnswerVip",
      accessor: "answerVip",
      displayInList: false,
      allowInForm: true,
      allowFilter: false,
      dataType: "string",
      width: 4,
      Cell: ({ value }) => <DefaultCell value={value} />,
    },
    {
      Header: "AnswerBack",
      accessor: "answerBack",
      displayInList: false,
      allowInForm: true,
      Cell: ({ value }) => <DefaultCell value={value} />,
      width: 4,
      dataType: "string",
    },
    {
      Header: "BusyReleaseInterval",
      accessor: "busyReleaseInterval",
      displayInList: false,
      allowInForm: true,
      allowFilter: false,
      dataType: "string",
      width: 4,
      validation: formControl.string().digitsOnly().nullable(),
      Cell: ({ value }) => <DefaultCell value={value} />,
    },

    {
      Header: "CampOnHoldMusic",
      accessor: "campOnHoldMusic",
      displayInList: false,
      allowInForm: true,
      allowFilter: false,
      dataType: "string",
      width: 4,
      Cell: ({ value }) => <DefaultCell value={value} />,
    },
    {
      Header: "ChimePath",
      accessor: "chimePath",
      displayInList: false,
      allowInForm: true,
      allowFilter: false,
      dataType: "string",
      width: 4,
      Cell: ({ value }) => <DefaultCell value={value} />,
    },
    {
      Header: "ChimeInterval",
      accessor: "chimeInterval",
      displayInList: false,
      allowInForm: true,
      allowFilter: false,
      dataType: "string",
      validation: formControl.string().digitsOnly().nullable(),
      width: 4,
      Cell: ({ value }) => <DefaultCell value={value} />,
    },
    {
      Header: "FromTime",
      accessor: "fromTime",
      displayInList: false,
      allowInForm: true,
      allowFilter: false,
      dataType: "date",
      controlType: "time",
      width: 4,
      Cell: ({ value }) => <DefaultCell value={value} />,
    },
    {
      Header: "ToTime",
      accessor: "toTime",
      displayInList: false,
      allowInForm: true,
      allowFilter: false,
      dataType: "date",
      controlType: "time",
      width: 4,
      Cell: ({ value }) => <DefaultCell value={value} />,
    },
    {
      Header: "Filepath",
      accessor: "filepath",
      displayInList: false,
      allowInForm: true,
      allowFilter: false,
      dataType: "string",
      width: 4,
      Cell: ({ value }) => <DefaultCell value={value} />,
    },
    {
      Header: "FailOver",
      accessor: "failOver",
      displayInList: false,
      allowInForm: true,
      allowFilter: false,
      dataType: "string",
      width: 4,
      Cell: ({ value }) => <DefaultCell value={value} />,
    },

    {
      Header: "Manufacturer Id",
      accessor: "manufacturerId",
      displayInList: false,
      allowInForm: true,
      allowFilter: false,
      dataType: "string",
      validation: formControl.string().digitsOnly().nullable(),
      width: 4,
      Cell: ({ value }) => <DefaultCell value={value} />,
    },
    {
      Header: "Model Code",
      accessor: "modelCode",
      displayInList: false,
      allowInForm: true,
      allowFilter: false,
      dataType: "string",
      width: 4,
      Cell: ({ value }) => <DefaultCell value={value} />,
    },
    {
      Header: "Name",
      accessor: "name",
      displayInList: false,
      allowInForm: true,
      allowFilter: false,
      dataType: "string",
      width: 4,
      Cell: ({ value }) => <DefaultCell value={value} />,
    },
    {
      Header: "NonworkingApp",
      accessor: "nonworkingApp",
      displayInList: false,
      allowInForm: true,
      allowFilter: false,
      dataType: "string",
      width: 4,
      Cell: ({ value }) => <DefaultCell value={value} />,
    },
    {
      Header: "NonworkingData",
      accessor: "nonworkingData",
      displayInList: false,
      allowInForm: true,
      allowFilter: false,
      dataType: "string",
      width: 4,
      Cell: ({ value }) => <DefaultCell value={value} />,
    },
    {
      Header: "NightRingTime",
      accessor: "nightRingTime",
      displayInList: false,
      allowInForm: true,
      allowFilter: false,
      dataType: "string",
      validation: formControl.string().digitsOnly().nullable(),
      width: 4,
      Cell: ({ value }) => <DefaultCell value={value} />,
    },
    {
      Header: "Assigned User",
      accessor: "assignedUser",
      displayInList: true,
      allowInForm: true,
      allowFilter: false,
      dataType: "string",
      controlType: "select",
      width: 4,
      Cell: ({ value }) => <DefaultCell value={value} />,
      options: {
        keyField: "username",
        keyDescription: "description",
        values: [],
        url: "user/dropdownList",
      },
    },
    {
      Header: "Strategy",
      accessor: "strategy",
      displayInList: true,
      allowInForm: true,
      Cell: ({ value }) => <DefaultCell value={value} />,
      controlType: "select",
      width: 4,
      options: {
        keyField: "id",
        keyDescription: "description",
        values: [
          {
            id: "ring-all",
            description: "Ring All",
          },
          {
            id: "longest-ideal-agent",
            description: "Longest Ideal Agent",
          },
          { id: "round-robin", description: "Round Robin" },
          { id: "top-down", description: "Top Down" },
          {
            id: "agent-with-least-talk-time",
            description: "Agent With Least Talk Time",
          },
          {
            id: "agent-with-fewest-calls",
            description: "Agent with Fewest Calls",
          },
          {
            id: "sequentially-by-agent-order",
            description: "Sequentially By Agent Order",
          },
          { id: "random", description: "Random" },
          { id: "ring-progressively", description: "Ring Progressively" },
          { id: "acd", description: "ACD" },
          { id: "console", description: "Console" },
        ],
      },
    },
    {
      Header: "Day Inbound Cos",
      accessor: "dayInboundCos",
      displayInList: false,
      allowInForm: true,
      allowFilter: false,
      dataType: "string",
      width: 4,
      Cell: ({ value }) => <DefaultCell value={value} />,
      controlType: "select",
      options: {
        keyField: "cos",
        keyDescription: "cos",
        values: [],
        url: "inboundCos/list/cos",
      },
    },
    {
      Header: "NightInboundCos",
      accessor: "nightInboundCos",
      displayInList: false,
      allowInForm: true,
      allowFilter: false,
      dataType: "string",
      controlType: "select",
      width: 4,
      Cell: ({ value }) => <DefaultCell value={value} />,
      options: {
        keyField: "cos",
        keyDescription: "cos",
        values: [],
        url: "inboundCos/list/cos",
      },
    },
    {
      Header: "DayOutboundCos",
      accessor: "dayOutboundCos",
      displayInList: false,
      allowInForm: true,
      allowFilter: false,
      dataType: "string",
      width: 4,
      controlType: "select",
      Cell: ({ value }) => <DefaultCell value={value} />,
      options: {
        keyField: "cos",
        keyDescription: "cos",
        values: [],
        url: "outboundCos/list/cos",
      },
    },
    {
      Header: "NightOutboundCos",
      accessor: "nightOutboundCos",
      displayInList: false,
      allowInForm: true,
      allowFilter: false,
      dataType: "string",
      controlType: "select",
      width: 4,
      Cell: ({ value }) => <DefaultCell value={value} />,
      options: {
        keyField: "cos",
        keyDescription: "cos",
        values: [],
        url: "outboundCos/list/cos",
      },
    },
    {
      Header: "OverrideMoh",
      accessor: "overrideMoh",
      displayInList: false,
      allowInForm: true,
      allowFilter: false,
      dataType: "string",
      width: 4,
      Cell: ({ value }) => <DefaultCell value={value} />,
    },
    {
      Header: "Acd Pickup Group",
      accessor: "acdPickupGroup",
      displayInList: false,
      allowInForm: true,
      allowFilter: false,
      dataType: "string",
      width: 4,
      Cell: ({ value }) => <DefaultCell value={value} />,
    },
    {
      Header: "PForkStr",
      accessor: "pforkStr",
      displayInList: false,
      allowInForm: true,
      allowFilter: false,
      dataType: "string",
      width: 4,
      Cell: ({ value }) => <DefaultCell value={value} />,
    },

    {
      Header: "Park Expiry Interval",
      accessor: "parkExpiryInterval",
      displayInList: false,
      allowInForm: true,
      allowFilter: false,
      dataType: "string",
      width: 4,
      validation: formControl.string().digitsOnly().nullable(),
      Cell: ({ value }) => <DefaultCell value={value} />,
    },
    {
      Header: "Ring Time",
      accessor: "ringTime",
      displayInList: false,
      allowInForm: true,
      allowFilter: false,
      dataType: "string",
      validation: formControl.string().digitsOnly().nullable(),
      width: 4,
      Cell: ({ value }) => <DefaultCell value={value} />,
    },
    {
      Header: "Rlu Code",
      accessor: "rluCode",
      displayInList: false,
      allowInForm: true,
      allowFilter: false,
      dataType: "string",
      width: 4,
      Cell: ({ value }) => <DefaultCell value={value} />,
    },
    {
      Header: "Sip Password",
      accessor: "sipPassword",
      displayInList: false,
      allowInForm: true,
      allowFilter: false,
      dataType: "string",
      controlType: "password",
      width: 4,
      Cell: ({ value }) => <DefaultCell value={value} />,
    },
    {
      Header: "Ivr Password",
      accessor: "ivrPassword",
      displayInList: false,
      allowInForm: true,
      allowFilter: false,
      dataType: "string",
      controlType: "password",
      width: 4,
      Cell: ({ value }) => <DefaultCell value={value} />,
    },
    {
      Header: "Serial Call",
      accessor: "serialCall",
      displayInList: false,
      allowInForm: true,
      allowFilter: false,
      dataType: "string",
      width: 4,
      Cell: ({ value }) => <DefaultCell value={value} />,
    },
    {
      Header: "Time zone",
      accessor: "timezone",
      displayInList: false,
      allowInForm: true,
      allowFilter: false,
      dataType: "string",
      width: 4,
      Cell: ({ value }) => <DefaultCell value={value} />,
    },
    {
      Header: "Text Path",
      accessor: "textPath",
      displayInList: false,
      allowInForm: true,
      allowFilter: false,
      dataType: "string",
      width: 4,
      Cell: ({ value }) => <DefaultCell value={value} />,
    },
    {
      Header: "TimeOut In Second",
      accessor: "timeOutInSecond",
      displayInList: false,
      allowInForm: true,
      allowFilter: false,
      dataType: "string",
      width: 4,
      Cell: ({ value }) => <DefaultCell value={value} />,
      validation: formControl.string().digitsOnly().nullable(),
    },
    {
      Header: "Transfer Number",
      accessor: "transferNumber",
      displayInList: false,
      allowInForm: true,
      allowFilter: false,
      dataType: "string",
      width: 4,
      Cell: ({ value }) => <DefaultCell value={value} />,
    },
    {
      Header: "Tenant Code",
      accessor: "tenantCode",
      displayInList: false,
      allowInForm: true,
      allowFilter: false,
      dataType: "string",
      width: 4,
      Cell: ({ value }) => <DefaultCell value={value} />,
    },

    {
      Header: "Model Code",
      accessor: "modelCode",
      displayInList: false,
      allowInForm: true,
      allowFilter: false,
      dataType: "string",
      width: 4,
      Cell: ({ value }) => <DefaultCell value={value} />,
    },
    {
      Header: "ManufacturerId",
      accessor: "manufacturerId",
      displayInList: false,
      allowInForm: true,
      allowFilter: false,
      dataType: "string",
      width: 4,
      Cell: ({ value }) => <DefaultCell value={value} />,
      validation: formControl.string().digitsOnly().nullable(),
    },

    {
      Header: "Did Number",
      accessor: "didNumber",
      displayInList: false,
      allowInForm: true,
      allowFilter: false,
      dataType: "string",
      width: 4,
      Cell: ({ value }) => <DefaultCell value={value} />,
    },
    {
      Header: "Dod Number",
      accessor: "dodNumber",
      displayInList: false,
      allowInForm: true,
      allowFilter: false,
      dataType: "string",
      width: 4,
      Cell: ({ value }) => <DefaultCell value={value} />,
    },

    {
      Header: "Cfa",
      accessor: "cfaData",
      displayInList: false,
      allowInForm: true,
      allowFilter: false,
      dataType: "string",
      width: 4,
      Cell: ({ value }) => <DefaultCell value={value} />,
    },
    {
      Header: "Is CallCenterBased",
      accessor: "isCallCenterBased",
      displayInList: false,
      allowInForm: true,
      allowFilter: false,
      dataType: "boolean",
      controlType: "boolean",
      width: 4,
      Cell: ({ value }) => <DefaultCell value={value} />,
    },
    {
      Header: "Is CampOnMode",
      accessor: "isCampOnMode",
      displayInList: false,
      allowInForm: true,
      allowFilter: false,
      dataType: "boolean",
      controlType: "boolean",
      width: 4,
      Cell: ({ value }) => <DefaultCell value={value} />,
    },
    {
      Header: "Acd Callback",
      accessor: "acdCallback",
      displayInList: false,
      allowInForm: true,
      allowFilter: false,
      dataType: "boolean",
      controlType: "boolean",
      width: 4,
      Cell: ({ value }) => <DefaultCell value={value} />,
    },
    {
      Header: "Record",
      accessor: "record",
      displayInList: false,
      allowInForm: true,
      allowFilter: false,
      dataType: "boolean",
      controlType: "boolean",
      width: 4,
      Cell: ({ value }) => <DefaultCell value={value} />,
    },
    {
      Header: "Srtp",
      accessor: "srtP",
      displayInList: false,
      allowInForm: true,
      allowFilter: false,
      dataType: "boolean",
      controlType: "boolean",
      width: 4,
      Cell: ({ value }) => <DefaultCell value={value} />,
    },
    {
      Header: "Tpi",
      accessor: "tpi",
      displayInList: false,
      allowInForm: true,
      allowFilter: false,
      dataType: "boolean",
      controlType: "boolean",
      width: 4,
      Cell: ({ value }) => <DefaultCell value={value} />,
    },
    {
      Header: "Voice mail",
      accessor: "voicemail",
      displayInList: false,
      allowInForm: true,
      allowFilter: false,
      dataType: "boolean",
      controlType: "boolean",
      width: 4,
      Cell: ({ value }) => <DefaultCell value={value} />,
    },
    {
      Header: "Zrtp",
      accessor: "zrtP",
      displayInList: false,
      allowInForm: true,
      allowFilter: false,
      dataType: "boolean",
      controlType: "boolean",
      width: 4,
      Cell: ({ value }) => <DefaultCell value={value} />,
    },
    {
      Header: "Auto Lift",
      accessor: "autoLift",
      displayInList: false,
      allowInForm: true,
      allowFilter: false,
      dataType: "boolean",
      controlType: "boolean",
      width: 4,
      Cell: ({ value }) => <DefaultCell value={value} />,
    },
    {
      Header: "Video Call",
      accessor: "videoCall",
      displayInList: false,
      allowInForm: true,
      allowFilter: false,
      dataType: "boolean",
      controlType: "boolean",
      width: 4,
      Cell: ({ value }) => <DefaultCell value={value} />,
    },
    {
      Header: "Sunday",
      accessor: "sunday",
      displayInList: false,
      allowInForm: true,
      allowFilter: false,
      dataType: "boolean",
      controlType: "boolean",
      width: 4,
      Cell: ({ value }) => <DefaultCell value={value} />,
    },
    {
      Header: "Monday",
      accessor: "monday",
      displayInList: false,
      allowInForm: true,
      allowFilter: false,
      dataType: "boolean",
      controlType: "boolean",
      width: 4,
      Cell: ({ value }) => <DefaultCell value={value} />,
    },
    {
      Header: "Tuesday",
      accessor: "tuesday",
      displayInList: false,
      allowInForm: true,
      allowFilter: false,
      dataType: "boolean",
      controlType: "boolean",
      width: 4,
      Cell: ({ value }) => <DefaultCell value={value} />,
    },
    {
      Header: "Wednesday",
      accessor: "wednesday",
      displayInList: false,
      allowInForm: true,
      allowFilter: false,
      dataType: "boolean",
      controlType: "boolean",
      width: 4,
      Cell: ({ value }) => <DefaultCell value={value} />,
    },
    {
      Header: "Thursday",
      accessor: "thursday",
      displayInList: false,
      allowInForm: true,
      allowFilter: false,
      dataType: "boolean",
      controlType: "boolean",
      width: 4,
      Cell: ({ value }) => <DefaultCell value={value} />,
    },
    {
      Header: "Friday",
      accessor: "friday",
      displayInList: false,
      allowInForm: true,
      allowFilter: false,
      dataType: "boolean",
      controlType: "boolean",
      width: 4,
      Cell: ({ value }) => <DefaultCell value={value} />,
    },
    {
      Header: "Saturday",
      accessor: "saturday",
      displayInList: false,
      allowInForm: true,
      allowFilter: false,
      dataType: "boolean",
      controlType: "boolean",
      width: 4,
      Cell: ({ value }) => <DefaultCell value={value} />,
    },
    {
      Header: "Isd",
      accessor: "isd",
      displayInList: false,
      allowInForm: true,
      allowFilter: false,
      dataType: "boolean",
      controlType: "boolean",
      width: 4,
      Cell: ({ value }) => <DefaultCell value={value} />,
    },
    {
      Header: "Std",
      accessor: "std",
      displayInList: false,
      allowInForm: true,
      allowFilter: false,
      dataType: "boolean",
      controlType: "boolean",
      width: 4,
      Cell: ({ value }) => <DefaultCell value={value} />,
    },
    {
      Header: "Local",
      accessor: "local",
      displayInList: false,
      allowInForm: true,
      allowFilter: false,
      dataType: "boolean",
      controlType: "boolean",
      width: 4,
      Cell: ({ value }) => <DefaultCell value={value} />,
    },
    {
      Header: "Intercom",
      accessor: "intercom",
      displayInList: false,
      allowInForm: true,
      allowFilter: false,
      dataType: "boolean",
      controlType: "boolean",
      width: 4,
      Cell: ({ value }) => <DefaultCell value={value} />,
    },
    {
      Header: "Action",
      accessor: "id",
      displayInList: true,
      allowInForm: false,
      Cell: ({ row, value }) => (
        <RowAction
          row={row}
          value={value}
          onEdit={onEdit}
          onDelete={onDelete}
        />
      ),
    },
  ];
};

export { getUpdateColumns };
